import { render, staticRenderFns } from "./BaseAsyncButton.vue?vue&type=template&id=22185e1d&scoped=true&"
import script from "./BaseAsyncButton.vue?vue&type=script&lang=ts&"
export * from "./BaseAsyncButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAsyncButton.vue?vue&type=style&index=0&id=22185e1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22185e1d",
  null
  
)

/* custom blocks */
import block0 from "./BaseAsyncButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports